<template>
  <div id="query" class="div_card">
    <div v-if="docRecord==null">      
      <el-alert
        title="資料讀取中…"
        type="info"
        show-icon
        center
        :closable="false">
      </el-alert>
    </div>
    <div v-else-if="docRecord!=null && docRecord[0].status==1">
      <el-table
        :data="docRecord"
        :border="true"
        style="width: 100%"
        :row-style="tableRowStyle"
        :header-cell-style="tableHeaderColor">
        <el-table-column
          prop="name"
          label="考生姓名"
          width="120">
          <template>
            <span class="badge badge-info" style="font-size:1.25rem">{{docRecord[0].name}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="note"
          label="狀態"
          width="800">
          <template>
            <span class="badge badge-warning" style="font-size: 1.25rem" 
                  :style="[1,2].indexOf(docRecord[0].showStatus)>-1? { 'background-color': '#5cb85c' } : { 'background-color': '#d9534f' }">{{docRecord[0].note}}</span> 
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="繳費單下載" v-if="docRecord[0].isPayment==0 && docRecord[0].isApproval==1"> 
          <template>
                <a :href="'./WebApi/Apply/GetBillFormPDF/'+this.setting.enrollID[0].codeName+'/'+docRecord[0].account" class="ncut-btn-type" v-if="docRecord[0].isPayment==0 && docRecord[0].isApproval==1"><span class="glyphicon glyphicon-download-alt" style="margin-right: 4px;" />繳費單下載(手機)<i class="el-icon-download"></i></a>
                <a href="#" @click="print(docRecord[0].account)" class="ncut-btn-type" v-if="docRecord[0].isPayment==0 && docRecord[0].isApproval==1">繳費單下載 <i class="el-icon-document"></i></a>              
          </template>
        </el-table-column> -->
        <!-- <el-table-column
          label="其它連結">
          <template>
            <ol style="font-size: medium;">
              <li v-if="(0 < docRecord[0].showStatus) && docRecord[0].flag2">
                <a href="#" @click="printEnvelopeData()">報名專用信封列印 <i class="el-icon-document"></i></a>
              </li>
            </ol>
          </template>
        </el-table-column> -->
      </el-table> <br/>
      <div v-if="docRecord[0].isPayment==0 && docRecord[0].isApproval==1">
        <a :href="'./WebApi/Apply/GetBillFormPDF/'+this.setting.enrollID[0].codeName+'/'+docRecord[0].account" class="ncut-btn-type" v-if="docRecord[0].isPayment==0 && docRecord[0].isApproval==1"><span class="glyphicon glyphicon-download-alt" style="margin-right: 4px;" />繳費單下載(手機)<i class="el-icon-download"></i></a>
        <a href="#" @click="print(docRecord[0].account)" class="ncut-btn-type" v-if="docRecord[0].isPayment==0 && docRecord[0].isApproval==1">繳費單下載 <i class="el-icon-document"></i></a>                       
      </div>     
    </div>
    <div v-else-if="docRecord!=null && docRecord[0].status==5">
      <el-alert
        title="請先完成網路報名。"
        type="error"              
        show-icon
        center
        :closable="false">
      </el-alert>
      <div style="padding: 0.5em 0 0; text-align:center;" 
                    v-html="docRecord[0].note"/>
    </div>
    <div v-else>
      <el-alert
        title="尚無資料，請耐心等候，謝謝!!"
        type="warning"
        show-icon
        center
        :closable="false">
      </el-alert>
    </div>
  </div> 
</template>


<script>
export default {
  name: 'query',
  data () {
    return {
        docRecord:null
    }
  },
  computed: {
    sysId () {
      return this.$store.getters.getSysId
    },
    setting () {
      return this.$store.getters.getSetting
    },
    enroll () {
      return this.$store.getters.getEnrollInfo
    },
    user () {
      return this.$store.getters.getUser
    }
  },
  methods: {
    tableRowStyle({ row, rowIndex }) {
      return 'background-color: #fffff0'
    },
    tableHeaderColor({row, rowIndex}) {
      if (rowIndex === 0) {
        return 'background-color: #EACD76;color: #4C221B;font-weight: 500;'
      }
    },
    printEnvelopeData(data) {
      let url = './WebApi/Apply/GetEnvelopePDF/'.concat(this.user.dId);
      let params = new URLSearchParams();
      params.append('cdn', this.cdnSelect);

      this.$http.get(url, {    
                  responseType: 'blob',
                  params: params
                }).then((response) => {
                  const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                  const link = document.createElement('a');
                  link.href = url;
                  link.setAttribute('target','_blank');
                  document.body.appendChild(link);
                  link.click();
                });
    },
    print: function(data) {
        let url = './WebApi/Apply/GetBillFormPDF/'.concat(this.setting.enrollID[0].codeName).concat('/').concat(data);
        let params = new URLSearchParams();
        params.append('cdn', this.cdnSelect);

        this.$http.get(url, {    
                        responseType: 'blob',
                        params: params
                  })
                  .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('target','_blank');
                    document.body.appendChild(link);
                    link.click();
                  })
    }
  },
  created () { 
    console.log('======created QueryView=====');
    var vm = this
    this.$http
        .get('./WebApi/Apply/GetEnrollStatus/'.concat(this.user.dId))
        .then(function(response) {
          if (response.data != null) {
            vm.docRecord = [response.data]
          } else {
            //vm.$message.error('對不起,讀取分發結果查詢失敗');
            this.$notify.error({
                                title: this.$t('message.Error_txt'),
                                dangerouslyUseHTMLString: true,
                                message: '<strong>對不起,讀取<i style="background:yellow;">報名結果</i>查詢失敗</strong>',
                                offset: 150
                              });
          }
        })
        .catch(function (error) {
          //vm.$message.error('對不起,網路連線失敗');
          vm.$notify.error({
                            title: vm.$t('message.Error_txt'),
                            dangerouslyUseHTMLString: true,
                            message: '<strong>對不起,網路連線失敗' + error+'</strong>',
                            offset: 150
                          });
        })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }
</style>



// WEBPACK FOOTER //
// src/components/QueryView.vue